import { createApp } from 'vue';
import store from 'shared/store';
import { createEventBus } from 'shared/tools/eventBus';
import FlyOutBasketActivator from './Components/FlyOutBasketActivator.vue';
import MiniBasketCount from './MiniBasketCount.vue';

const miniBasketCountMounts = document.querySelectorAll('[data-feature="mini-basket-count"]');
const eventBus = createEventBus();

miniBasketCountMounts.forEach(miniBasketCountMount => {
    if (miniBasketCountMount) {
        const app = createApp({
            name: 'MiniBasketCountApp',
        });
        app.use(store);
        app.config.globalProperties.$eventBus = eventBus;
        app.component('fly-out-basket-activator', FlyOutBasketActivator);
        app.component('mini-basket-count', MiniBasketCount);
        app.mount(miniBasketCountMount);
    }
});
